import React, { Component } from 'react'
import classnames from 'classnames'
import { Col, Row } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import Divider from '@material-ui/core/Divider'
import { withStyles } from '@material-ui/core/styles'
import Columns from '../../styles/columns'
import CardStyles from '../../styles/cards'
import IconStyles from '../../styles/icons'
import ButtonStyles from '../../styles/buttons'
import NotificationStyles from '../../styles/components/react-notification-system'
import TitledLabel from '../../controls/TitledLabel'
import TitledLine from '../../controls/TitledLine'
import RBButton from '../../controls/RBButton'
import BackButton from '../../controls/BackButton'
import Icon from '@material-ui/core/Icon'
import Loading from '../../widgets/Loading'
import { localize } from '../../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { fetchClaimLines } from '../../redux/actions/claimLineActions'
import { fetchEOBFile } from '../../redux/actions/eobActions'
import { push } from 'connected-react-router'
import NotificationSystem from 'react-notification-system'
import GenericModal from '../../widgets/common/GenericModal'
import { ClaimStatus } from '../../redux/SubmitClaim/Common'
// import saveAs from 'file-saver'
import ClaimReceipts from '../Claims/ClaimReceipts'

class Claimlines extends Component {
  constructor (props) {
    super(props)

    this.backToSummary = this.backToSummary.bind(this)
    this.pushDetails = this.pushDetails.bind(this)
    this.fileDownloadError = this.fileDownloadError.bind(this)
    this.downloadEOBFile = this.downloadEOBFile.bind(this)
    this.notificationSystem = React.createRef()

    this.state = {
      showGenericModal: false
    }
  }
  componentDidMount () {
    this.props.fetchClaimLines(this.props.claimId)
  }

  backToSummary () {
    this.props.goBack()
  }

  pushDetails (claimLineId) {
    const claimType = window.location.href.split('/')[5]
    this.props.push(`/Claims/${this.props.claimId}/${claimType}/ClaimLines/Details/${claimLineId}`)
  }

  renderClaimLine (claimLine, indx) {
    const { classes = {} } = this.props
    if ((claimLine.claimLineStatus === 'Pending' || claimLine.claimLineStatus === 'En Attente') && (this.props.claimLines && this.props.claimLines.receipts.length > 0)) {
      return null
    } else {
      return (<div key={indx}>
        <Card className={classnames(classes.summaryCard, classes.baseCard)}>
          <Row between='lg' className='summaryHeader'>
            <Col lg={8} md={8} xs={12}>
              <Row between='xs'>
                <Col className={'claim_responsive_padding'}>
                  <TitledLine title='pages.claims.claimNumber' value={claimLine.claimCode} className='claimId claimsTitleLine' />
                </Col>
                <Col className={'claim_responsive_padding'}>
                  <TitledLine title='pages.claims.status' value={claimLine.claimLineStatus} className={`${claimLine.claimLineStatus} claimsTitleLine`} />
                </Col>
                <Col className={'claim_responsive_padding'}>
                  <TitledLine title='pages.claims.name' value={claimLine.patientName} className='claimId claimsTitleLine' />
                </Col>
              </Row>
            </Col>
            <Col lg={4} md={12} xs={12}>
              <Row end='lg'>
                <Col>
                  {claimLine.explanationOfBenefitsFileExists === true
                    ? <RBButton
                      label={localize('pages.claims.eob')}
                      variant='outlined'
                      className={classes.fixedHeightButton}
                      onClick={() => { this.fetchEoBFile(claimLine.eoBFileName) }}
                      icon={<Icon className={classes.borderedIcon}>arrow_downward</Icon>} />
                    : null}
                  <RBButton
                    label={localize('pages.claims.claimDetails')}
                    variant='outlined'
                    className={classes.fixedHeightButton}
                    onClick={() => { this.pushDetails(claimLine.claimLineId) }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.claims.ProcDate' value={claimLine.processedDate} format='date' />
            </Col>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.claims.dateOfService' value={claimLine.serviceDate} format='date' />
            </Col>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.claims.amountSubmitted' value={claimLine.submitedAmmount} format='currency' />
            </Col>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.claims.amountPaid' value={claimLine.totalPayAmmount} format='currency' showRaw={ClaimStatus.isPending(claimLine.totalPayAmmount)} />
            </Col>
            <Col {...Columns.max6} className='wordBreak'>
              <TitledLabel title='pages.claims.service' value={claimLine.serviceCodeDescription} />
            </Col>
            <Col {...Columns.max6}>
              <TitledLabel title='pages.claims.benefit' value={claimLine.benefitName} />
            </Col>
          </Row>
        </Card>
      </div>
      )
    }
  }

  render () {
    const pending = /^(Pending|En\sAttente)$/
    const claimLines = this.props.claimLines

    if (this.props.isLoading) {
      return (<Loading message={localize('common.loadingContent')} />)
    }

    return (
      <div className='claimLine'>
        <NotificationSystem ref={this.notificationSystem} style={NotificationStyles} />
        <BackButton label={localize('pages.claimLines.backButton')} />
        {(claimLines && pending.test(claimLines && claimLines.claimLines[0].claimLineStatus)) && ((claimLines && claimLines.receipts.length > 0)) ? null : <h4 className='sectionHeading'>{localize('pages.claims.claimLines')}</h4>}
        {
          ((this.props.claimLines && this.props.claimLines.claimLines) || []).map((claimLine, index) => {
            return this.renderClaimLine(claimLine, index)
          })}
        {this.props.claimLines && this.props.claimLines.receipts.length > 0 && pending.test(claimLines && claimLines.claimLines[0].claimLineStatus) ? <ClaimReceipts claimLines={this.props.claimLines} /> : null}
        {this.state.showGenericModal
          ? <GenericModal
            open={this.state.showGenericModal}
            handleClose={() => {
              this.setState({ showGenericModal: false })
            }}
            modal
            message='Something went wrong while downloading resource. Please try again'
          /> : null}
      </div>
    )
  }

  fetchEoBFile (fileName) {
    this.props.fetchEOBFile(fileName, this.downloadEOBFile, this.fileDownloadError)
  }

  fileDownloadError () {
    const notification = this.notificationSystem.current
    const { downloadError = {} } = this.props
    const { rawResponse, message } = downloadError
    if (notification === undefined) { return }

    // clear all notifications
    notification.clearNotifications()

    // show the notification if available
    if (downloadError) {
      const serverError = downloadError && rawResponse && rawResponse.error_description
      notification.addNotification({
        title: `${serverError || message}`,
        level: 'error',
        position: 'tc',
        autoDismiss: 0
      })
    }
  }

  downloadEOBFile () {
    /*eslint-disable */
    if (typeof (this.props.eobFile) === 'object' && !this.props.eobFile.hasErrorField) {
      this.props.eobFile.map((file, index) => {
        const pdfFielBlob = this.b64toBlob(file.fileContentField, 'application/pdf')
        const fileName = file.fileNameField
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
          window.navigator.msSaveOrOpenBlob(pdfFielBlob, fileName)
        } else {
          var downloadLink = document.createElement('a')
          downloadLink.download = fileName
          downloadLink.innerHTML = 'Download File'
          var URL = window.URL || window.webkitURL
          downloadLink.href = URL.createObjectURL(pdfFielBlob)
          if (!('webkitURL' in window)) {
            // Firefox requires the link to be added to the DOM before it can be clicked.
            downloadLink.href = URL.createObjectURL(pdfFielBlob)
            downloadLink.onclick = this.destroyDowloadLink
            downloadLink.style.display = 'none'
            document.body.appendChild(downloadLink)
          }

          downloadLink.click()
          URL.revokeObjectURL(downloadLink)
        }
      })
    } else {
      this.setState({ showGenericModal: true })
    }
  }
  /* eslint-enable */
  b64toBlob (b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = window.atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    const blob = new window.Blob(byteArrays, { type: contentType })
    return blob
  }

  destroyDowloadLink (event) {
    document.body.removeChild(event.target)
  }
}

function mapStateToProps (state, ownProps) {
  return {
    claimLines: state.ClaimLineReducer.claimLines,
    error: state.ClaimLineReducer.error,
    downloadError: state.EOBReducer.error,
    eobFile: state.EOBReducer.eobFile || '',
    isLoading: state.ClaimLineReducer.isLoading,
    claimId: ownProps.claimId,
    claimType: ownProps.claimType
  }
}

const ConnectedClaimLines = connect(mapStateToProps,
  {
    fetchClaimLines,
    fetchEOBFile,
    push
  })(injectIntl(Claimlines))

const Styles = {
  ...CardStyles,
  ...IconStyles,
  ...ButtonStyles
}

export default withStyles(Styles)(ConnectedClaimLines)



// WEBPACK FOOTER //
// ./src/widgets/Claims/ClaimLines.js